import Header from './Header';
import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { ToastContainer } from 'react-toastify';
import PrivateRoute from './PrivateRoute';

import Login from './Login';
import Users from './Users';
import Rooms from './Rooms';
import Policies from './Policies';
import Announcements from './Announcements';
import Issues from './Issues';


@inject('userStore')
@withRouter
@observer
export default class App extends React.Component {
    
    render() {
        return (
            <div>
                <Header />
                <Switch>
                    <Route path="/Login" component={Login} />
                    <PrivateRoute path="/Issues" component={Issues} />
                    <PrivateRoute path="/Announcements" component={Announcements} />
                    <PrivateRoute path="/Policies" component={Policies} />
                    <PrivateRoute path="/Rooms" component={Rooms} />
                    <PrivateRoute path="/" component={Users} />
                </Switch>
                <ToastContainer />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/App.js